import axios from 'axios';
import { data } from 'flickity';
import clean from './dapi-clean';

//TODO restore Error Catching

const dAPI = {
    //TODO: do some validation on the url to make sure it starts with a '/'
    //TODO: break this out into its own object so it can have its own version number etc.
    url: function( uri ) {
        return process.env.REACT_APP_API_HOST + 'v1' + uri;
    },
    self: function() {
        return '/users/' + window.localStorage.getItem( '_id' );
    },
    headers: function() {
        var headers = {};
        try {
            var auth = ( typeof window.localStorage !== 'undefined' ) && window.localStorage.getItem( 'token' );
            if( !!auth ) {
                headers.Authorization = 'Bearer ' + auth;
            }
        } catch (e) {
            console.warn( e );
        }
        return headers;
    },
    get: function( url, data={}, options={} ) {
        options.headers = options.headers === undefined ? true : options.headers;

        return axios( {
            url: `${ process.env.REACT_APP_API_HOST }v1${ url }`,
            method: 'get',
            headers: options.headers ? this.headers() : {},
            params: data,
        } )
        .then( ( response ) => {
            if( options.responseForm === 'raw' ) {
                return response;
            }
            if( options.responseForm === 'data' ) {
                return response.data;
            }

            if( response.data.rows ) {
                return response.data.rows;
            }
            return response.data;
        } );
    },
    post: function( url, data={}, options={}, ) {
        options.headers = options.headers === undefined ? true : options.headers;

        return axios( {
            url: `${ process.env.REACT_APP_API_HOST }v1${ url }`,
            method: 'post',
            headers: options.headers ? this.headers() : {},
            data: data,
        } )
        .then( ( response ) => {
            if( options.responseForm === 'raw' ) {
                return response;
            }
            if( options.responseForm === 'data' ) {
                return response.data;
            }

            if( response.data.rows ) {
                return response.data.rows;
            }
            return response.data;
        } );
    },
    patch: function( url, data={}, options={}, ) {
        options.headers = options.headers === undefined ? true : options.headers;

        return axios( {
            url: `${ process.env.REACT_APP_API_HOST }v1${ url }`,
            method: 'patch',
            headers: options.headers ? this.headers() : {},
            data: data,
        } )
        .then( ( response ) => {
            if( options.responseForm === 'raw' ) {
                return response;
            }
            if( options.responseForm === 'data' ) {
                return response.data;
            }
            if( response.data.rows ) {
                return response.data.rows;
            }
            return response.data;
        } );
    },
    put: function (url, data={}, options={} ) {
        if(url.indexOf('http') == -1) {
            url = process.env.REACT_APP_API_HOST + 'v1' + url;
        }
        return axios( {
            url: `${ url }`,
            method: 'put',
            data: data,
        } )
        .then( ( response ) => {
            return response.data;
        } );
    },
    delete: function( url, options={} ) {
        options.headers = options.headers === undefined ? true : options.headers;

        return axios( {
            url: `${ process.env.REACT_APP_API_HOST }v1${ url }`,
            method: 'delete',
            headers: options.headers ? this.headers() : {},
        } );
    },
    clean: clean,
};

export default dAPI;
